<style src="@/assets/css/login_parts.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_input.css" type="text/css" media="all" scoped></style>

<template>
  <!-- ▼ contents -->
  <div id="login" v-bind:style="getStyle">
    <!-- ▼ header  -->
    <section id="loginHeader">
      <h1>{{displayIrkn.irnm}}</h1>
      <h2>WEB健診予約システム</h2>
      <p>{{displayIrkn.egnm}} Online Reservation Service</p>
    </section>
    <!-- ▲ header END -->
    <!-- ▽ login -->
    <section class="login">
      <dl class="member">
        <dt></dt>
        <dd>
          <ul>
            <li><b>メールアドレス</b><input type="text" id="idNo" v-model="loginForm.mailAssress"></li>
            <li><b>パスワード</b><input type="password" id="pwNo" v-model="loginForm.password"></li>
            <li class="btnLst"><button id="loginBtn" v-on:click="onLogin" v-bind:disabled="!isButtonEnabled">ログイン</button></li>
          </ul>
        </dd>
        <dd><a v-on:click="onForgetPassword">パスワードを忘れた方へ</a></dd>
      </dl>
    </section>
    <!-- △ login END -->
    <section class="mainCF">
      <!-- コピーライト使用しなくなった為、コメントアウト、mainCFのコンテナは残す -->
      <!--<h2>けんしんWEB</h2><p class="copy">&copy; アルコクリニック Online Reservation Service</p>-->
    </section>
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
      <dt slot="modal-header">入力エラー</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
      </dd>
      <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
    </modalWindow>
    <!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.authError.isShow" v-on:close="onAuthErrorModalClose">
      <dt slot="modal-header">認証エラー</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.authError.messages"></errorMessageBox>
      </dd>
      <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onAuthErrorModalClose">閉じる</a></dd>
    </modalWindow>
    <!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
      <dt slot="modal-header">システムエラー</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
      </dd>
      <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
    </modalWindow>
    <!-- モーダルWindow E -->
  </div>
</template>
<script>
import { CommonTop } from '@/api'
import { Auth } from '@/api'
import * as types from '@/store/mutation-types'
import * as ErrorCodes from '@/components/Utility/error-codes'
import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
import ModalWindow from '@/components/Utility/ModalWindow'
import * as UtilityValidation from '@/components/Utility/UtilitiValidation'
import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

export default {
  // モジュール名
  name: 'CommonTop',
  // 使用コンポーネント
  components: {
    // エラー表示コンポーネント
    'errorMessageBox': ErrorMessageBox,
    // モーダルウィンドウ表示コンポーネント
    'modalWindow': ModalWindow,
  },
  // データ
  data() {
    return {
      // ログインフォーム
      loginForm: {
        mailAssress: '',
        password: ''
      },
      // 各ボタン及びリンクの活性非活性
      // trueの時disabled=falseとなり活性
      // falseの時disabled=trueとなり非活性
      isButtonEnabled: false,
      // 医療機関毎の表示
      displayIrkn: {
        irnm: '',
        egnm: '',
        showflagSelectCourse: true,
        showflagNewHealthInsurance: true,
      },
      // モーダルウィンドウ
      modal: {
        validationError: {
          messages: [],
          isShow: false
        },
        authError: {
          messages: [
            'ユーザーIDまたはパスワードが正しくありません。'
          ],
          isShow: false
        },
        systemError: {
          messages: [
            'システムエラーです。',
            '内容をもう一度ご確認ください。'
          ],
          isShow: false
        }
      }
    }
  },
  computed: {
    getStyle: function() {

      var resultStyle = ''

      var strPre = "background-image: url('"
      var strPost = "');"

      if(this.$store.state.commonUserInfo.hmpg != '') {
        resultStyle =  strPre + this.$store.state.commonUserInfo.hmpg + strPost
      }

      return resultStyle
    }
  },
  // ライフサイクルフック: created
  created: function () {
    UtilityConsoleLog.consoleLog('CommonTop::created Start')

    if (this.$route.params.routeParam != null) {
      this.firstDisplay()
    } else {
      // :TODO 共通のエラー画面に遷移
    }

    UtilityConsoleLog.consoleLog('CommonTop::created End')
  },
  methods: {
    // 表示系--------------------------------------------------S
    // 初期表示
    firstDisplay: function () {
      UtilityConsoleLog.consoleLog('CommonTop::firstDisplay Start')

      // ストアの状況に関わらず
      // ログアウト処理を行う
      this.$store.commit(types.COMMON_AUTH_LOGOUT)

      // 初期表示用のデータを取得
      this.apiFirstDisplay()

      UtilityConsoleLog.consoleLog('CommonTop::firstDisplay End')
    },
    // 表示系--------------------------------------------------E
    // イベント系--------------------------------------------------S
    // ログインボタン押下時
    onLogin: function () {

      UtilityConsoleLog.consoleLog('CommonTop::onLogin Start')

      var errorMessagesList = this.validationOnLogin()

      // 入力チェック
      if (errorMessagesList.length > 0) {
        // 必須入力時エラー
        this.onValidationErrorModalOpen(errorMessagesList)
        UtilityConsoleLog.consoleLog('CommonTop::onLogin End')
        return
      }

      // ログイン処理を行う
      this.apiLogin()

      UtilityConsoleLog.consoleLog('CommonTop::onLogin End')
    },
    // 「パスワードを忘れた方へ」リンク押下時
    onForgetPassword: function () {
      UtilityConsoleLog.consoleLog('CommonTop::onForgetPassword Start')

      // isButtonEnabledがfalseの場合初期表示時の
      // 処理が終わっていないので処理を中断する
      if(!this.isButtonEnabled) {
        UtilityConsoleLog.consoleLog('CommonTop::onForgetPassword End')
        return
      }

      // パスワードを忘れた方用ページに遷移
      this.$router.push("/CommonForgetPassword")

      UtilityConsoleLog.consoleLog('CommonTop::onForgetPassword End')
    },
    // 「健保制度を利用せず個人として新規予約」ボタン押下時
    onSelectCourse: function () {
      UtilityConsoleLog.consoleLog('CommonTop::onSelectCourse Start')

      CommonTop.GetCurrentNend()
        .then(({ responce }) => {
          // アプリケーション異常が出ない処理ではあるが
          // 一応アプリケーションエラー処理も実装
          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

            // 年度を含む個人の時の各情報をストアに格納
            this.$store.commit(
              types.COMMON_KOJIN,
              { nend: responce.data.nend })

            // コース選択に遷移
            this.$router.push("/CommonSelectCourse")

          } else {
            this.onSystemErrorModalOpen()
          }
        }).catch(() => {
        this.onSystemErrorModalOpen()
      })

      UtilityConsoleLog.consoleLog('CommonTop::onSelectCourse End')
    },
    // 「健保制度を利用して新規予約」ボタン押下時
    onNewHealthInsurance: function () {
      UtilityConsoleLog.consoleLog('CommonTop::onNewHealthInsurance Start')

      // 新規健保予約に遷移
      this.$router.push("/CommonNewHealthInsurance")

      UtilityConsoleLog.consoleLog('CommonTop::onNewHealthInsurance End')
    },
    // イベント系--------------------------------------------------E
    // 通信系--------------------------------------------------S
    // 初期表示
    apiFirstDisplay: function () {
      UtilityConsoleLog.consoleLog('CommonTop::apiFirstDisplay Start')

      // URLから各医療機関URLパラメーター用識別子を取得した後、
      // （.../#/CommonTop/各医療機関URLパラメーター用識別子）
      // 医療機関コードを取得し、ストアに格納する
      CommonTop.FirstDisplay({
        param: this.$route.params.routeParam
      }).then(({ responce }) => {

        if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

          // 医療機関コードを保存
          this.$store.commit(
            types.COMMON_SETIRKNINFO,
            {
              ircd: responce.data.ircd,
              pram: responce.data.pram,
              irnm: responce.data.irnm,
              ktel: responce.data.ktel,
              uktk: responce.data.uktk,
              hmpg: responce.data.hmpg
            })

          // 医療機関個別の情報を取得し、画面に表示
          this.displayIrkn.irnm = responce.data.irnm
          this.displayIrkn.egnm = responce.data.egnm

          if ('1' == responce.data.nwkb) {
            // 1:個人予約＋健保予約
            // 両ボタンを表示
            this.showflagSelectCourse = true
            this.showflagNewHealthInsurance = true
          } else if ('2' == responce.data.nwkb) {
            // 2:個人予約
            // 「健保制度を利用せず個人として新規予約」ボタンを表示
            this.showflagSelectCourse = true
            this.showflagNewHealthInsurance = false
          } else if ('3' == responce.data.nwkb) {
            // 3:健保予約
            // 「健保制度を利用して新規予約」ボタンを表示
            this.showflagSelectCourse = false
            this.showflagNewHealthInsurance = true
          }

          this.isButtonEnabled = true

        } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
          || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
          || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
          // :TODO 各医療機関URLパラメーター用識別子関連の
          // エラー時の処理は考慮する必要がある
          this.onSystemErrorModalOpen()
        }
      }).catch(() => {
        // :TODO 各医療機関URLパラメーター用識別子関連の
        // エラー時の処理は考慮する必要がある
        this.onSystemErrorModalOpen()
      }).finally(() => {
        UtilityConsoleLog.consoleLog('CommonTop::apiFirstDisplay End')
      })
    },
    // ログイン時通信処理
    apiLogin: function () {
      UtilityConsoleLog.consoleLog('CommonTop::apiLogin Start')
      // サーバーが正常に稼働しているかを確認する
      CommonTop.GetAliveServer()
        .then(() => {
          // 一般ユーザーID=医療機関コード + メールアドレス
          var tempUserId = this.$store.state.auth.ircd +
            "_" + this.loginForm.mailAssress

          // ログイン処理
          Auth.login({
            userId: tempUserId,
            password: this.loginForm.password
          }).then(({ responce }) => {

            // 一般ユーザーの認証情報を登録
            this.$store.commit(
              types.COMMON_AUTH_LOGIN,
              {
                token: responce.data.access_token,
                userId: responce.data.userId
              })

            // 一般ユーザー情報を取得
            CommonTop.GetUserInfo({
              ircd: this.$store.state.auth.ircd,
              userId: responce.data.userId,
              token: this.$store.state.auth.token
            }).then(({ responce }) => {

              if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

                // 一般ユーザー情報の認証情報を登録
                this.$store.commit(
                  types.COMMON_USERINFO_SETUSERINFO,
                  {
                    trsq: responce.data.trsq,
                    name: responce.data.name,
                    jgcd: responce.data.jgcd,
                    hksh: responce.data.hksh,
                    sex: responce.data.sex,
                    btdyYear: responce.data.btdyYear,
                    btdyMonth: responce.data.btdyMonth,
                    btdyDate: responce.data.btdyDate,
                    age: responce.data.age,
                    hfkb: responce.data.hfkb
                  })

                // マイページに遷移
                this.$router.push("/CommonMyPage")

              } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION) {
                // 相関チェックエラーの場合
                // （一般ユーザーでない場合）は認証エラーにする

                this.onAuthErrorModalOpen()
              } else {

                // システムエラー時
                this.onSystemErrorModalOpen()
              }
            }).catch(() => {
              // システムエラー時
              this.onSystemErrorModalOpen()
            })
          }).catch(() => {
            this.onAuthErrorModalOpen()
          })
        }).catch(() => {
        this.onSystemErrorModalOpen()
      }).finally(() => {
        UtilityConsoleLog.consoleLog('CommonTop::apiLogin End')
      })
    },
    // 通信系--------------------------------------------------E
    // その他--------------------------------------------------S
    // ログインボタン押下時入力チェック
    validationOnLogin: function () {

      UtilityConsoleLog.consoleLog('CommonTop::validationOnLogin Start')

      // エラーメッセージリスト
      var errorMessagesList = []

      var tempErrorMessage = []
      // メールアドレスの入力チェック
      tempErrorMessage = this.validationMailAssress()
      tempErrorMessage.forEach((item) => {
        errorMessagesList.push(item)
      })
      // パスワードチェック
      tempErrorMessage = this.validationPassword()
      tempErrorMessage.forEach((item) => {
        errorMessagesList.push(item)
      })

      UtilityConsoleLog.consoleLog('CommonTop::validationOnLogin End')

      return errorMessagesList
    },
    // メールアドレスの入力チェック
    validationMailAssress: function () {

      UtilityConsoleLog.consoleLog('CommonTop::validationMailAssress Start')

      var propertyNameMailAssress = 'メールアドレス'
      var lengthMailAssress = 60

      // エラーメッセージリスト
      var errorMessagesList = []

      if (UtilityValidation.checkStrIsNull(this.loginForm.mailAssress)) { // Nullチェック
        errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrIsNull(
            propertyNameMailAssress))
      } else if (UtilityValidation.checkStrIsKaraMoji(this.loginForm.mailAssress)) { // 空文字チェック
        errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
            propertyNameMailAssress))
      } else if (!UtilityValidation.checkStrMaxLength(this.loginForm.mailAssress, lengthMailAssress)) { // 桁数チェック
        errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrMaxLength(
            propertyNameMailAssress, String(lengthMailAssress)))
      } else if (!UtilityValidation.checkStrEmail(this.loginForm.mailAssress)) { // Email書式チェック
        errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrEmail(
            propertyNameMailAssress))
      }

      UtilityConsoleLog.consoleLog('CommonTop::validationMailAssress End')

      return errorMessagesList
    },
    // パスワードチェック
    validationPassword: function () {

      UtilityConsoleLog.consoleLog('CommonTop::validationPassword Start')

      var propertyNamePassword = 'パスワード'

      // エラーメッセージリスト
      var errorMessagesList = []

      if (UtilityValidation.checkStrIsNull(this.loginForm.password)) { // Nullチェック
        errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrIsNull(
            propertyNamePassword))
      } else if (UtilityValidation.checkStrIsKaraMoji(this.loginForm.password)) { // 空文字チェック
        errorMessagesList.push(
          UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
            propertyNamePassword))
      }

      UtilityConsoleLog.consoleLog('CommonTop::validationPassword End')

      return errorMessagesList
    },
    // バリデーションエラーモーダルとしてエラーモーダルを開く
    onValidationErrorModalOpen: function (errorMessages) {

      UtilityConsoleLog.consoleLog('CommonTop::onValidationErrorModalOpen Start')

      var tempMessages = [
        '入力エラーです。',
        '以下の内容をもう一度ご確認ください'
      ]

      errorMessages.forEach((item)=>{
        tempMessages.push(item)
      })

      this.modal.validationError.messages = tempMessages
      this.modalOpen('validationError')

      UtilityConsoleLog.consoleLog('CommonTop::onValidationErrorModalOpen End')
    },
    // バリデーションエラーモーダルを閉じる
    onValidationErrorModalClose: function () {
      UtilityConsoleLog.consoleLog('CommonTop::onValidationErrorModalClose Start')

      this.modalClose('validationError')

      UtilityConsoleLog.consoleLog('CommonTop::onValidationErrorModalClose End')
    },
    // 認証エラーモーダルとしてエラーモーダルを開く
    onAuthErrorModalOpen: function () {

      UtilityConsoleLog.consoleLog('CommonTop::onAuthErrorModalOpen Start')

      this.modalOpen('authError')

      UtilityConsoleLog.consoleLog('CommonTop::onAuthErrorModalOpen End')
    },
    // 認証エラーモーダルとしてエラーモーダルを閉じる
    onAuthErrorModalClose: function () {
      UtilityConsoleLog.consoleLog('CommonTop::onAuthErrorModalClose Start')

      this.modalClose('authError')

      UtilityConsoleLog.consoleLog('CommonTop::onAuthErrorModalClose End')
    },
    // システムエラーモーダルとしてエラーモーダルを開く
    onSystemErrorModalOpen: function () {

      UtilityConsoleLog.consoleLog('CommonTop::onSystemErrorModalOpen Start')

      this.modalOpen('systemError')

      UtilityConsoleLog.consoleLog('CommonTop::onSystemErrorModalOpen End')
    },
    // システムエラーモーダルを閉じる
    onSystemErrorModalClose: function () {
      UtilityConsoleLog.consoleLog('CommonTop::onSystemErrorModalClose Start')

      this.modalClose('systemError')

      UtilityConsoleLog.consoleLog('CommonTop::onSystemErrorModalClose End')
    },
    // モーダルウィンドウを開く
    modalOpen: function (modalName) {

      UtilityConsoleLog.consoleLog('CommonTop::modalOpen Start')

      // すべてのモーダルを閉じる
      this.allModalClose()

      this.modal[modalName].isShow = true

      UtilityConsoleLog.consoleLog('CommonTop::modalOpen End')
    },
    // モーダルウィンドウを閉じる
    modalClose: function (modalName) {

      UtilityConsoleLog.consoleLog('CommonTop::modalClose Start')

      this.modal[modalName].isShow = false

      UtilityConsoleLog.consoleLog('CommonTop::modalClose End')
    },
    // 全てのモーダルを閉じる
    allModalClose: function() {
      for(var key in this.modal) {
        this.modal[key].isShow = false
      }
    }
    // その他--------------------------------------------------E
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Common/Login/CommonLogin.vue